/*
 * Reference-counted body scroll lock. Save-and-restore locking breaks when
 * two lockers release out of order — e.g. a portaled PDF viewer suspends
 * (keep-alive tab hidden) while the command palette is open, and the palette
 * then "restores" the viewer's `hidden`, leaving the fronted page
 * unscrollable. Counting restores scrolling only when the LAST lock releases.
 */
let lockCount = 0;

export function acquireBodyScrollLock(): () => void {
  lockCount += 1;
  document.body.style.overflow = "hidden";
  let released = false;
  return () => {
    if (released) return;
    released = true;
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) document.body.style.overflow = "";
  };
}
